import { createSelector } from 'reselect';

import { ScreenRef } from '../../App/types/screenRef';
import { selectScreenRefDataMap } from './selectScreenRefDataMap';

export const selectRefDataInitialized = (screen: ScreenRef) =>
  createSelector([selectScreenRefDataMap], (screenRefDataMap) => !!screenRefDataMap[screen]);
